import {ListRequest, ListResponse} from "../../../generated/protocol";
import {AdminEntityService} from "./AdminEntityService";
import {injectable} from "inversify";

export interface GenericArrayEntityService<E> extends AdminEntityService<E> {
    setEntities(entities: E[]): void;

    getEntities(): E[];

    getFilteredEntities(listRequest: ListRequest): E[];
}

export interface GenericItem {
    id: string;
}

export class GenericListResponse<E extends GenericItem> implements ListResponse {
    items: E[];
    nrOfResults: number;

    constructor(entities: E[], nrOfResults: number) {
        this.items = entities;
        this.nrOfResults = nrOfResults;
    }
}

@injectable()
export class GenericArrayEntityServiceImpl<E extends GenericItem> implements GenericArrayEntityService<E> {
    entities: E[] = [];

    setEntities(entities: E[]): void {
        this.entities = entities;
    }

    getEntities(): E[] {
        return this.entities;
    }

    getFilteredEntities(listRequest: ListRequest): E[] {
        return this.filter(this.entities, listRequest);
    }

    save(entity: E): Promise<E> {
        this.entities.push(entity);

        return new Promise<E>((resolve, reject) => {
            resolve(entity);
        });
    }

    list(listRequest: ListRequest): Promise<ListResponse> {
        let self = this;
        return new Promise<ListResponse>((resolve, reject) => {
            let response: GenericListResponse<E> = self.wrap(self.filter(self.entities, listRequest), listRequest);
            resolve(response);
        });
    }

    getEntity(id: string): Promise<E> {
        let self = this;
        return new Promise<E>((resolve, reject) => {
            let entity: E = self.entities.find((entity: E) => entity.id == id);
            entity ? resolve(entity) : reject();
        });
    }

    remove(id: string): Promise<{}> {
        return undefined;
    }

    private filter(entities: E[], listRequest: ListRequest): E[] {
        let result: E[] = this.entities.filter((entity: E) => {
            let match = true;
            for (let field in listRequest) {
                if (!(entity as any)[field]) {
                    continue;
                }
                match = match && ((listRequest as any)[field] === "" || (listRequest as any)[field] === "ANY" || (entity as any)[field] == (listRequest as any)[field]);
            }
            return match;
        });

        result.sort((a, b) => {
            let aField = a[listRequest.orderBy];
            let bField = b[listRequest.orderBy];

            return aField == bField ? 0 : (listRequest.ascending ? (aField > bField ? 1 : -1) : (aField > bField ? -1 : 1));
        });
        return result;
    }

    private wrap(filtered: E[], listRequest: ListRequest): GenericListResponse<E> {
        let paginated: E[] = filtered.slice(listRequest.offset, listRequest.offset + listRequest.limit);
        let result: GenericListResponse<E> = new GenericListResponse<E>(paginated, filtered.length);

        return result;
    }
}


// WEBPACK FOOTER //
// ./src/app/service/admin/GenericArrayEntityService.ts